import React from "react";
import "./Forms.css";
import { useTranslation } from "react-i18next";
const LoomisForm = ({ carrier }) => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarriers__form_wrap">
      <div className="cuscarriers__form_logo">
        <img src={carrier?.logo_url} />
      </div>
      <div className="cuscarriers__form_content">
        <div className="cuscarriers__fcntnt_fieldwrap">
          <label className="cuscarriers__fcntnt_fieldlbl">{t("carriers.custom.labels.accountName")}</label>
          <input
            type="text"
            className="cuscarriers__fcntnt_field"
            placeholder={t("carriers.custom.placeholders.accountName")}
          />
        </div>
      </div>
    </div>
  );
};

export default LoomisForm;
